import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent {
  constructor(private apiService: ApiService, private router: Router) {}

  isLoading = true;
  search = '';
  usersData: any = [];
  dtOptions: DataTables.Settings = {};
  currentSortParam = '';

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full',
      ordering: true,
      processing: true,
      serverSide: true,
      searching: true,
      search: true,
      rowCallback: (row: Node, data: any, index: number) => {
        const self = this;
        const detailsButton = $('td', row).find('.user-details');
        $(detailsButton).off('click');
        $(detailsButton).on('click', () => {
          this.router.navigateByUrl('user-details/' + data.id);
        });
        return row;
      },
      columns: [
        {
          title: 'Nume',
          data: 'firstName',
        },
        {
          title: 'Prenume',
          data: 'lastName',
        },
        {
          title: 'E-mail',
          data: 'email',
        },
        {
          title: 'Rol',
          data: 'role',
        },
        {
          title: 'Tipul contului',
          data: 'loginType',
        },
        {
          title: 'Detalii',
          render: (data: any, type: any, row: any, meta: any) => {
            return '<a class="user-details" style="text-decoration: none; color:#4298B5; cursor: pointer">Detalii</a>';
          },
          orderable: false,
        },
      ],
      ajax: (data: any, callback, settings) => {
        this.isLoading = true;
        this.apiService
          .getAllUsers(
            data.search.value,
            data.length,
            data.start,
            this.currentSortParam
          )
          .subscribe(
            (response: any) => {
              this.usersData = response.results.map((row: any) => {
                return {
                  firstName: this.getUserFirstNameString(row),
                  lastName: row.lastName || '-',
                  email: row.email || '-',
                  role: this.getUserRoleString(row.role),
                  loginType: this.getUserTypeString(row.loginType),
                  id: row.id,
                };
              });

              setTimeout(() => {
                callback({
                  draw: data.draw,
                  data: this.usersData,
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                });
              }, 50);
            },
            (error: any) => {
              console.error('API Error:', error);
              this.isLoading = false;
            }
          );
      },

      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        },
      },
    };
  }

  sortTable(columnName: string) {
    this.currentSortParam =
      this.currentSortParam === `${columnName}|asc`
        ? `${columnName}|desc`
        : `${columnName}|asc`;
  }

  getUserFirstNameString(row: any) {
    let firstNameString = '';

    if (row.loginType === 'anonymous') {
      firstNameString = 'Guest #' + row.id.split('-')[0];
    } else {
      firstNameString = row.firstName || '-';
    }

    return firstNameString;
  }

  getUserRoleString(role: string) {
    let roleString = '';

    switch (role) {
      case 'user':
        roleString = 'Utilizator';
        break;
      case 'admin':
        roleString = 'Administrator';
        break;
      case 'parkingAgent':
        roleString = 'Agent de parcare';
        break;
      default:
        roleString = role;
        break;
    }

    return roleString;
  }

  getUserTypeString(loginType: string) {
    let loginTypeString = '';

    switch (loginType) {
      case 'anonymous':
        loginTypeString = 'Anonim';
        break;
      case 'google':
        loginTypeString = 'Google';
        break;
      case 'facebook':
        loginTypeString = 'Facebook';
        break;
      case 'apple':
        loginTypeString = 'Apple';
        break;
      case 'email':
        loginTypeString = 'Email';
        break;
      case 'devonly':
        loginTypeString = 'Developer';
        break;
      default:
        loginTypeString = loginType;
        break;
    }

    return loginTypeString;
  }
}
